<template>
    <div class="budgetary-international-document" :class="{ completed: documentCompleted }">
        
        <assertive-question v-model="isInternational" @input="update">
            ¿El documento cuya firma se legitima quiere que surja efecto fuera de España?
            
            <numeric-question slot="afirmative" v-model="foliosNumber" :min="1" @input="update">
                Indíquenos el nº de folios del documento que desea legitimar.
                
                <fieldset slot="answered" class="form-group" :class="{ completed: countriesSelected }">
                    <p>
                        <strong>Indíquenos los países donde quiere que surja efecto el documento:</strong>
                    </p>
                    <multiselect
                        slot="multiple" 
                        v-model="selectedCountries" yarn
                        multiple 
                        placeholder="Busca o añade un país" 
                        selectLabel="Pulsa para seleccionar" 
                        selectedLabel="Seleccionado" 
                        deselectLabel="Pulsa para quitar" 
                        :options="countries" 
                        track-by="alpha2Code" 
                        label="name" 
                        open-direction="above" 
                        ref="countriesSelector" 
                        @input="update">
                        <span slot="noResult" class="bg-faded">No hay coincidencias</span>
                    </multiselect>
                    <!--<el-select
                            id="country_id"
                            v-model="selectedCountries"
                            multiple
                            placeholder="Busca o añade un país"
                            style="width: 100%;">
                        <el-option
                                v-for="country in countries"
                                :key="country.alpha2Code"
                                :label="country.name"
                                :value="country.alpha2Code">
                        </el-option>
                    </el-select>-->
                </fieldset>

                <assertive-question slot="answered" v-model="isUrgent" v-if="countriesSelected" afirmativeLabel="Urgente" negativeLabel="Normal" @input="update">
                    ¿Desea tramitar en el Colegio de Notarios la apostilla con carácter normal o urgente?
                </assertive-question>

            </numeric-question>

        </assertive-question>

    </div>
</template>

<script>
    import Multiselect from "vue-multiselect"
    export default {
        components: {
            Multiselect
        },

        data: function () {
            return {
                cost: 0,
                untaxedCosts: 0,
                completed: false,
                countries: window.countries,

                isInternational: null,
                foliosNumber: null,
                selectedCountries: [],
                isUrgent: null,

                apostilles: 0,
                legalizations: 0,
            }
        },

        computed: {
            countriesSelected: function () {
                return this.selectedCountries.length;
            },
            documentCompleted: function () {
                if ( this.$parent.$options.name == 'accordion' ) {
                    this.$parent.$slots.title[1].elm.innerHTML = this.completed ? 'COMPLETADO' : 'FALTA COMPLETAR';
                    this.$parent.$slots.title[1].elm.className = this.completed ? 'text-success' : 'text-warning';
                }
                return this.completed;
            },
            costs: function () {
                return { cost: this.cost, untaxedCosts: this.untaxedCosts };
            },
        },

        mounted: function () {
            //
        },

        methods: {
            update: function () {
                this.completed = this.hasBeenCompleted();
                this.calculate();
                this.$emit( 'updated', this.completed );
            },
            hasBeenCompleted: function () {
                if ( this.isInternational === false ) return true;
                return this.isUrgent != null;
            },
            calculate: function () {
                this.cost = this.untaxedCosts = 0;

                if (this.isInternational) {
                  this.$emit('update:hasInternationalDocument', true)
                } else {
                  this.$emit('update:hasInternationalDocument', false)
                }

                if ( ! this.isInternational || this.selectedCountries.length == 0 || this.isUrgent == null ) return this.costs;

                // Coste de la apostilla y/o legalización según urgencia.
                let costByUrgency = this.isUrgent ? 26.37 : 13.17;

                // En caso de que haya tanto apostillas como legalizaciones, se contará el precio por cada tipo distinto.
                this.apostilles = _.filter( this.selectedCountries, [ 'apostille', true ] );
                this.legalizations = _.filter( this.selectedCountries, [ 'apostille', false ] );

                if ( this.apostilles.length && this.legalizations.length ) costByUrgency *= 2;

                // Sumar el coste de apostillas y/o legalizaciones.
                this.untaxedCosts += costByUrgency;

                return this.costs;
            },
            getJSON: function () {
                let json = [];

                json.push( { 
                    "name": "¿El documento cuya firma se legitima quiere que surja efecto fuera de España?",
                    "value": this.isInternational 
                } );
                json.push( { 
                    "name": "Indíquenos el nº de folios del documento que desea legitimar.", 
                    "value": this.foliosNumber 
                } );
                json.push( { 
                    "name": "Indíquenos los países donde quiere que surja efecto el documento:", 
                    "value": this.selectedCountries 
                } );
                json.push( { 
                    "name": "Apostillas a realizar:", 
                    "value": this.apostilles
                } );
                json.push( { 
                    "name": "Legalizaciones a realizar:", 
                    "value": this.legalizations
                } );
                json.push( { 
                    "name": "¿Desea tramitar en el Colegio de Notarios la apostilla con carácter normal o urgente?",
                    "value": this.urgent ? 'Urgente' : this.selectedCountries.length ? 'Normal' : null
                } );

                return json;
            },
        }
    }
</script>

<style lang="scss">
    @import "../../../../sass/variables";

    .budgetary-international-document {

        .multiselect {

            .multiselect__tags {
                border-radius: 0;
                border: 0.15rem solid rgba(0, 0, 0, 0.15);
                padding: 1rem 40px 1rem 8px;
            }

            .multiselect__select {
                padding-top: 1rem;
                padding-bottom: 1rem;
                height: 53px;
            }

            .multiselect__input, .multiselect__single {
                margin-bottom: 0;
            }

            .multiselect__content-wrapper {
                //position: relative;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/budgetary/legitimations/InternationalDocument.vue